import React from 'react'
import { Link } from "react-router-dom"
import { Row, Col, Space, Typography, Form, Input, Button, Select, Table, AutoComplete, message } from 'antd'
import { reqOrganism, reqSamplesInfo, reqScaffoldInfo, reqSearchFeature } from '../../api'

const { Paragraph } = Typography
const { Option } = Select

class SearchFeature extends React.Component {
    state = {
        // form 表单状态
        species: '',
        species_options: [],
        sample: '',
        sample_options: [],
        feature_type: '',
        chr_options: '',
        loc_start: '',
        loc_end: '',
        feature_id: '',
        keyword: '',
        disabled: false,    // 控制submit按钮的可用状态
        // 结果table状态 
        title: '',
        loading: false,
        has_data: false,
        searchResult: '',
        pagination: {
            current: '',
            pageSize: '',
            total: '',
            showSizeChanger: false,
            showQuickJumper: true,
        }
    }
    
    formRef = React.createRef()

    onFinish = async (values) => {
        const { species, sample, feature_type, loc_chr, loc_start, loc_end, keyword } = values
  	    let { feature_id } = values

        this.setState({
            disabled: true,
            loading: true
        })
		
		if (feature_id) {
            feature_id = feature_id.toLowerCase()       // elasticsearch 的模糊检索索引用的是小写字母，所以这里转换成小写再查询，否则匹配不到
        }

        const param = {
            sample: sample,
            feature_type: feature_type,
            seqid: loc_chr,
            feature_start__gte: loc_start,
            feature_end__lt: loc_end,
            feature_id__contains: feature_id,
            text: keyword,
            page: 1
        }

        let table_title = ''
        const searchResult = await reqSearchFeature(param)
        if (searchResult.code === 0) {
            table_title = () => {
                return <span><b>{searchResult.data.count}</b> records were returned.</span>
            }

            this.setState({
                species: species,
                sample: sample,
                feature_type: feature_type,
                loc_chr: loc_chr,
                loc_start: loc_start,
                loc_end: loc_end,
                feature_id: feature_id,
                keyword: keyword,
                disabled: false,
                title: table_title,
                loading: false,
                has_data: true,
                searchResult: searchResult.data,
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    onSpeciesChange = async (val) => {
        this.formRef.current.setFieldsValue({ 
            sample: '',
            loc_chr: ''
        })
        if (val) {
            const results = await reqSamplesInfo(val)
            let sample_options = ''
            if (results.code === 0) {
                sample_options =  results.data.map((item) => {
                    return <Option value={item['sample']} key={item['sample']}>{item['sample']}</Option>
                })
            }

            this.setState({
                species: val,
                sample_options: sample_options
            })
        }

        this.setState({
            species: val
        })
    }

    onSampleChange = async (val) => {
        this.formRef.current.setFieldsValue({ 
            loc_chr: ''
        })

        if (val) {
            const results = await reqScaffoldInfo(val)
            let chr_options = ''
            if (results.code === 0) {
                chr_options =  results.data.map((item) => {
                    return <Option value={item['seqid']} key={item['seqid']}>{item['seqid']}</Option>
                })
            }
        
            this.setState({
                sample: val,
                chr_options: chr_options
            })
        }
        
        this.setState({
            sample: val
        })
    }

    //分页、排序、筛选变化时触发
    onTableChange = async (pagination, filters, sorter) => {
        const { species, sample, feature_type, loc_chr, loc_start, loc_end, feature_id, keyword} = this.state
        const { current } = pagination
        const param = {
            sample: sample,
            feature_type: feature_type,
            seqid: loc_chr,
            feature_start__gte: loc_start,
            feature_end__lt: loc_end,
            feature_id: feature_id,
            text: keyword,
            page: current
        }

        const searchResult = await reqSearchFeature(param)
        if (searchResult.code === 0) {
            this.setState({
                searchResult: searchResult.data,
                pagination: {
                    current: current,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    // 表单重置
    onReset = () => {
        this.formRef.current.resetFields()
        this.setState({
            chr_options: []
        })
    }

    async componentDidMount() {
        let species_options = []

        const species_results = await reqOrganism()
        if (species_results.code === 0) {
            species_options = species_results.data.map((item) => {
                return <Option value={item['species']} key={item['id']}>{item['species']}</Option>
            })
        } else {
            message.error('Request failed. ' + species_results.message)
        }

        this.setState({
            species_options: species_options,
        })
    }

    render() {
        const { species_options, sample_options, chr_options, disabled, title, loading, has_data, searchResult, pagination } = this.state
        
        const layout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 6 },
            colon: false
        }
        const tailLayout = {
            wrapperCol: { offset: 4, span: 12 },
        }

        const columns = [
            {
                title: 'Name',
                dataIndex: 'feature_id',
                render: text => <Link to={"/feature/" + text} target="_blank">{text}</Link>
            },
            {
                title: 'Type',
                dataIndex: 'feature_type',
            },
            {
                title: 'Location',
                dataIndex: 'feature_location',
            },
            /*
            {
                title: 'Blast vs Arabidopsis',
                dataIndex: 'blast_vs_arabidopsis_match',
            },
            {
                title: 'Blast vs nr',
                dataIndex: 'blast_vs_nr_match',
            },
            {
                title: 'Blast vs swissprot',
                dataIndex: 'blast_vs_swissprot_match',
            },
            {
                title: 'Blast vs uniprot trembl',
                dataIndex: 'blast_vs_uniprot_trembl_match',
            },
            {
                title: 'GO',
                dataIndex: 'go_match',
            },
            {
                title: 'IPR',
                dataIndex: 'ipr_match',
            },
            {
                title: 'Kegg2pathway',
                dataIndex: 'kegg2pathway_match',
            },
            {
                title: 'Kegg2orthologs',
                dataIndex: 'kegg2orthologs_match',
            },
            */
        ]

        if (searchResult) {
            for (let v of searchResult.results){
                v['key'] = v['feature_id']
            }
        }

        return (
            <React.Fragment>
                <Form {...layout} name="search-feature" ref={this.formRef} className="search-feature-form" initialValues={{feature_type: 'gene'}} onFinish={this.onFinish}>
                    <Paragraph>
                        Search genes, mRNA, transcripts by species, dataset, genome location, name and/or keyword. For keyword, enter any protein name of homologs, KEGG term/EC number, GO term, or InterPro term.
                    </Paragraph>
                    <Form.Item name="species" label="Species" rules={[{ required: true }]}>
                        <Select placeholder="Select species" allowClear onChange={this.onSpeciesChange}>
                            {species_options}
                        </Select>
                    </Form.Item>
                    <Form.Item name="sample" label="Sample" rules={[{ required: true }]}>
                        <Select placeholder="Select sample" showSearch showArrow allowClear onChange={this.onSampleChange}>
                            {sample_options}
                        </Select>
                    </Form.Item>
                    <Form.Item name="feature_type" label="Feature Type" rules={[{ required: true }]}>
                        <Select allowClear>
                            <Option value="gene">Gene</Option>
                            <Option value="mRNA">mRNA</Option>
                            <Option value="polypeptide">Polypeptide</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="Genome Location" wrapperCol={{span: 24}}>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="loc_chr" label="chr">
                                            <Select placeholder="Select chr" showSearch showArrow allowClear style={{width: 200}}>
                                                {chr_options}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="loc_start" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input placeholder="location start position" />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="loc_end" label="and" 
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input placeholder="location end position" />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item name="feature_id" label="Gene/Transcript ID" 
                        rules={[
                            { 
                                type: 'string',
                                max: 128
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item name="keyword" label="Keyword"
                        rules={[
                            { 
                                type: 'string',
                                max: 128
                            }
                        ]}
                    >
                        <Input disabled={true} />
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                        <Row>
                            <Col span={12}>
                                <Space>
                                    <Button type="primary" disabled={disabled} htmlType="submit" block>
                                        Submit
                                    </Button>
                                    <Button htmlType="button" disabled={disabled} onClick={this.onReset}>
                                        Reset
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
                <Table bordered title={title} loading={loading} has_data={has_data} columns={columns} dataSource={searchResult.results} size="middle" sticky={true} pagination={pagination} onChange={this.onTableChange} className="search-result-table" />
            </React.Fragment>
        )
    }
}

export default SearchFeature
